<template>
  <div id="framedBot">
    <transition-group name="langTrans" mode="out-in">
      <!-- --------------------- ENGLISH --------------------- -->
      <div v-if="english" class="inner" key="english">
        <div id="wrapper">
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                Framed
                <span
                  class="lastname"
                  style="cursor: auto; border-bottom: none"
                >
                  Bot
                </span>
              </h1>
              <p>
                I am in a virtual photography discord server called Framed,
                where people with the same hobby discuss with each others and
                share their stuff.
                <br /><br />
                We have a channel dedicated to sharing screenshots with a rule
                that ask people to not share more than 5 shot a day. The problem
                is that sometime the rule isn't being followed, and some people
                post 5 shots in the morning and 5 others in the evening.
                <br /><br />
                We were mostly cool about this, since it wasn't like we were
                being flooded, but the server kept growing, more people joined
                and new game were released... then we started to complain about
                that.
                <br /><br />
                One day, I'm watching youtube and I stumble upon a video where a
                guy shows how simple it is to setup a discord bot, and so I
                start to code (one could say my youtube recommendations are
                nerdy). I show it to the founder and then FramedPolice is born.
                (and got renamed later)
                <br /><br />
                <img ondragstart="return false" src="../assets/shotchart.png" />
                The graphic shows the posting channel activity before and after
                the bot came.
                <br /><br />
                Since I had fun coding in python, I wanted to continue working
                on that bot and add other useful feature. And that's how I
                implemented a command that search for data from a Google Sheet
                curated by
                <a
                  href="https://originalnicodr.pythonanywhere.com/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  >originalnicodr</a
                >, and also do some scrapping on a wiki website. <br /><br />
                <img
                  ondragstart="return false"
                  src="../assets/camCmdAction.jpg"
                />
                <br /><br />
                Later on, I also added some games and little features for the
                discord server, like a bingo, connect 4, a wordle like game,
                etc...<br /><br />
                <span style="display: flex; justify-content: center">
                  <img
                    ondragstart="return false"
                    class="sideBySideImg"
                    src="../assets/bingoScreenshot.png"
                  /> </span
                ><br />
                <img
                  ondragstart="return false"
                  src="../assets/connect4Screenshot.png"
                />
                I also coded a replay system to watch the whole match simply
                after the end of the game
                <a
                  href="https://connect4-replay.netlify.app/?data=add-right-add-left-add-right-right-add-left-left-add-maxRight-add-left-left-left-add"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  >by clicking a link</a
                >
                after the end of the game. <br />
                And also a wordle like game specific for the server<br /><br />
                <span style="display: flex; justify-content: center">
                  <img
                    ondragstart="return false"
                    class="sideBySideImg"
                    src="../assets/framedleScreenshot.png"
                  />
                </span>
              </p>
            </div>
          </section>
        </div>
      </div>

      <!-- --------------------- FRENCH --------------------- -->
      <div v-if="!english" class="inner" key="french">
        <div id="wrapper">
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                Framed
                <span
                  class="lastname"
                  style="cursor: auto; border-bottom: none"
                >
                  Bot
                </span>
              </h1>
              <p>
                Pas de version française disponible, veuillez lire la version
                anglaise
              </p>
            </div>
          </section>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "FramedBot",
  props: {
    english: Boolean,
  },
};
</script>

<style scoped>
.sideBySideImg {
  max-width: 50%;
}
</style>